/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Table, TableHead, TableRow, TableCell, TextField, CircularProgress } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { FixedSizeList } from 'react-window';
import GlobalField from './GlobalField';

import Actions from '../../../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
  headerStyle : {
    color : '#707070',
    backgroundColor : '#F5F5F5',
    fontSize : 11,
    border : 'none'
  }
})


class GlobalFieldList extends Component {
      state = {
        options : [],
        open : false,
        loading : false,
        loadingText : "Loading...",
        search_term : "",
        noOptionsText : "Enter at least 3 characters to filter."
      }

      onChangeHandle = (value) => {
        this.setState({...this.state, search_term : value}, () => {
            if (this.state.search_term.length > 2) {
                this.setState({...this.state, loading : true, loadingText: "Loading..."}, () => this.search())
            } else {
                this.setState({...this.state, loading : false, options : [], loadingText: "Enter at least 3 characters to filter.", noOptionsText : "Enter at least 3 characters to filter."})
            }
        })
      }

      search = () => {
          Actions('http_request', {
              url : "/sainapse/ifc/search",
              method : "post",
              data : {
                  ic_name : this.props.ic_name,
                  version : this.props.version,
                  key : this.state.search_term
              }
          }).then(res => {
              let options = res.data.result.Result.global_fields
              this.setState({...this.state, loading : false, loadingText : "", options : options, noOptionsText : options.length === 0 ? "No Results..." : "Enter at least 3 characters to filter."})
          })
      }

      render () {
        var toPX = require('to-px')
        console.log("IFC Global Field List: ", this.props.global_fields)
        const { classes } = this.props
        return (
          <ThemeProvider theme = {blue_theme}>
              {this.props.show_search && <Autocomplete
                  onOpen={() => {
                      this.setState({...this.state, open : true});
                  }}
                  onClose={() => {
                      this.setState({...this.state, open : false, loading : false, noOptionsText : "Enter at least 3 characters to filter.", options: []});
                  }}
                  open = {this.state.open}
                  loading = {this.state.loading}
                  options = {this.state.options}
                  openOnFocus = {true}
                  getOptionLabel = {(option) => option.global_field}
                  noOptionsText = {this.state.noOptionsText}
                  renderInput={(params) => <TextField 
                      {...params}
                      style = {{margin : '5px', width : '23vw'}} 
                      label={this.props.search_label} 
                      variant="outlined" 
                      size = 'small'
                      onChange={ev => this.onChangeHandle(ev.target.value)}
                      InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {this.state.loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                  />}
                  renderOption = {(global_field) => {
                      return (
                        <GlobalField
                          ic_name = {this.props.ic_name} 
                          version = {this.props.version} 
                          global_field_display_name = {this.props.global_field_display_name}
                          margin
                          variant = "elevated" 
                          global_field_data = {global_field}
                          field_in_focus = {this.props.field_in_focus}
                          select_global_field = {(global_field) => this.props.select_global_field(global_field)}
                          mapping_global_field = {this.props.mapping_global_field}
                          show_options = {false}
                          show_score  = {this.props.show_score}
                          group_in_focus = {this.props.group_in_focus}
                          map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                          cursor = {this.props.cursor}
                          refresh_report_and_data = {this.props.refresh_report_and_data}
                        />
                      )
                  }}
              />}
              <TableHead>
                <TableRow style = {{width : '90%'}}>
                  <TableCell 
                        className = {classes.headerStyle}
                        style = {{width : '18vw', paddingLeft : '20px'}}
                        padding = 'none' 
                        size = 'small'
                        align = 'left'
                  >Name</TableCell>
                  {this.props.show_score && <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                  >Score</TableCell>}
                </TableRow>
              </TableHead>
              <FixedSizeList height = {this.props.height} width = {this.props.width} itemSize = {65} itemCount = {this.props.global_fields.length}>
                {({index , style}) => (
                    <div style = {style} >
                      <GlobalField
                        ic_name = {this.props.ic_name} 
                        version = {this.props.version} 
                        global_field_display_name = {this.props.global_field_display_name}
                        margin
                        variant = "elevated" 
                        global_field_data = {this.props.global_fields[index]}
                        field_in_focus = {this.props.field_in_focus}
                        select_global_field = {(global_field) => this.props.select_global_field(global_field)}
                        mapping_global_field = {this.props.mapping_global_field}
                        show_options = {this.props.show_options}
                        show_score  = {this.props.show_score}
                        group_in_focus = {this.props.group_in_focus}
                        map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                        cursor = {this.props.cursor}
                        refresh_report_and_data = {this.props.refresh_report_and_data}
                      />
                    </div>
                )}
              </FixedSizeList>
          </ThemeProvider>
        );
      }
}

export default withStyles(styles)(GlobalFieldList)
